module.exports = __webpack_public_path__ + "static/media/zealix-2.4c8a5675.jpg";